export enum DisplayRuleType {
  show = 0,
  hide = 1
}